<template>
	<div class="relative mb-4 flex min-w-[420px] items-center max-md:min-w-0">
		<div
			class="relative w-full overflow-hidden rounded border"
			:class="notificationStyles.wrapper"
		>
			<div class="flex items-stretch justify-start bg-white">
				<div
					class=" min-h-full px-3 py-2"
					:class="notificationStyles.iconContainer"
				>
					<component :is="notificationStyles.icon" />
				</div>
                
				<div
					class="w-full py-2.5 pr-8 pl-4 text-[14px] leading-[20px] font-medium"
					:class="notificationStyles.body"
				>
					<!-- The link reads as the end of the sentence (Figma 5551:22267). The message is plain text here. -->
					<p v-if="notification.link">
						{{ notification.message }}
						<RouterLink
							:to="notification.link.to"
							class="text-won-green underline"
							@click="dismiss"
						>
							{{ notification.link.text }}
						</RouterLink>
					</p>
					<template v-else>
						<div v-html="notification.message" />
						<span
							v-if="notification.actionText"
							class="cursor-pointer text-won-green underline"
							@click="handleActionClick"
						>
							{{ notification.actionText }}
						</span>
					</template>
				</div>
			</div>
		</div>
        
		<xIcon
			class="absolute right-2 cursor-pointer"
			classes="w-6 h-6"
			@click="dismiss"
		/>
	</div>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useNotifications } from '../../store/notifications.store';

import xCircle from '../../icons/x-circle.vue';
import xIcon from '../../icons/x-icon.vue';
import CheckIcon from '../../icons/radio-checked.vue';
import WarningIcon from '../../icons/warning.vue';

const router = useRouter();
const notificationsStore = useNotifications();
const props = defineProps({
	notification: {
		type: Object,
		default: null
	}
});

const { notification } = toRefs(props);

const dismiss = () => notificationsStore.remove(notification.value.id);

const handleActionClick = () => {
	if (notification.value?.actionClickCb) {
		notificationsStore.runAction(notification.value.id);

		return;
	}

	if (notification.value?.url) {
		router.push({ path: notification.value.url });
	}
	dismiss();
};

const notificationClasses = {
	error: {
		body: 'bg-won-red-light',
		iconContainer: 'bg-won-red',
		wrapper: 'border-won-red',
		icon: xCircle
	},
	success: {
		body: 'bg-won-green-light',
		iconContainer: 'bg-won-green',
		wrapper: 'border-won-green',
		icon: CheckIcon
	},
	warning: {
		body: 'bg-won-yellow-light',
		iconContainer: 'bg-won-yellow',
		wrapper: 'border-won-yellow',
		icon: WarningIcon
	}
};

const notificationStyles = computed(() => {
	return notificationClasses[notification.value.type.toLowerCase()] || notificationClasses.error;
});
</script>
